import {createApp} from 'vue';
import App from './App.vue';
import router from './router/';
import store from './store/';
import {createHead} from "@vueuse/head";
import VueLazyload from 'vue-lazyload';
import i18n from './locales';
/*import './src/styles/output.css' // 路径需与实际文件位置一致*/
import '@/styles/global.css'; // 全局颜色变量配置
import '@/styles/variables.css'; // 主题颜色配置
import '@/assets/css/tailwind.css';
import 'swiper/css'; // 引入 Swiper 的基础样式
import 'swiper/css/pagination'; // 引入分页样式
import 'swiper/css/autoplay'; // 引入自动播放样式
// 引入百度统计的 JavaScript 代码
import './baiduAnalytics.js';

// 移除全局引入 Element Plus 的代码
// import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css';
// import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

const app = createApp(App);
// 创建 head 实例
// main.ts
const head = createHead({
    titleTemplate: '%s | 数字贸易国际合作城市法律服务平台' // 自动追加后缀
})

app.use(VueLazyload, {
    preLoad: 1.3,
    /*    error: 'dist/error.png', // 可选：错误图片路径
        loading: 'dist/loading.gif', // 可选：加载中图片路径*/
    attempt: 1
});

app.use(i18n);

app.use(head);


// 初始化 Vuex store 状态
const storedIsLoggedIn = localStorage.getItem('isLoggedIn');
if (storedIsLoggedIn === '1') {
    store.commit('SET_LOGGED_IN', true);
}

// 移除全局使用 Element Plus 的代码
// app.use(ElementPlus, { locale: zhCn });

app.use(store).use(router).mount('#app');

